import { render, staticRenderFns } from "./TableContractsDetails.vue?vue&type=template&id=34381de6&"
import script from "./TableContractsDetails.vue?vue&type=script&lang=js&"
export * from "./TableContractsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports